import React from 'react';
import Contact from '../components/Contact';
import ScrollToTop from '../components/ScrollToTop';

function ContactPage() {
  return (
    <>
      <ScrollToTop />
      <Contact />
    </>
  );
}

export default ContactPage;
